import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Button, IconButton } from 'shared/ui'
import { DeviceSettingsContent, DeviceSettingsVariantEnum } from 'entities/DeviceSettings'
import { RecordPlayer } from 'widgets/Record/ui/RecordActions/RecordPlayer/RecordPlayer'
import { type VoicemailDropStore } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop'
import styles from './styles.module.scss'

type IRecordAudioModalProps = {
  store: VoicemailDropStore
}

export const RecordAudioModal = observer(({ store }: IRecordAudioModalProps) => {
  const { initRecordAudio } = store
  const { recordStore } = store.recordAudioStore
  const {
    deviceSettingsStore,
    onStartRecord,
    startLoading,
    stream,
    startRecord,
    pauseRecord,
    onPause,
    onResume,
    onRestart,
    onFinish,
    isAudioLimit,
  } = recordStore

  useEffect(() => {
    initRecordAudio()

    return () => store.recordAudioStore.onUnmount()
  }, [])

  return (
    <div className={styles.wrap}>
      <div className={styles.settings}>
        <DeviceSettingsContent
          deviceSettingsStore={deviceSettingsStore}
          variant={DeviceSettingsVariantEnum.modal}
        />
      </div>
      {startRecord ? (
        <div className={styles.recordControls}>
          <div className={styles.controlsLeft}>
            {pauseRecord ? (
              <IconButton
                onClick={onResume}
                icon={'microphone'}
                size={'large'}
                color={'secondary'}
                variant={'icon'}
                fontSize={20}
                disabled={isAudioLimit}
                ariaLabel='RecordAudioModal_resume'
                tooltipProps={{
                  label: 'Resume',
                  placement: 'top',
                }}
              />
            ) : (
              <IconButton
                onClick={onPause}
                icon={'pause'}
                size={'large'}
                color={'secondary'}
                variant={'icon'}
                fontSize={20}
                ariaLabel='RecordAudioModal_pause'
                tooltipProps={{
                  label: 'Pause',
                  placement: 'top',
                }}
              />
            )}
            <IconButton
              onClick={() => {
                onRestart()
                deviceSettingsStore.initStream()
              }}
              icon={'back'}
              size={'large'}
              color={'secondary'}
              variant={'icon'}
              fontSize={20}
              ariaLabel='RecordAudioModal_restart'
              tooltipProps={{
                label: 'Restart',
                placement: 'top',
              }}
            />
          </div>

          <RecordPlayer recordStore={recordStore} size={'large'} />

          <IconButton
            onClick={() => void onFinish()}
            size={'large'}
            icon={'check1'}
            fontSize={20}
            color={pauseRecord ? 'transparent' : 'primary'}
            ariaLabel='RecordAudioModal_finish'
          />
        </div>
      ) : (
        <Button
          loading={startLoading}
          icon={'microphone'}
          typeBtn={'contained'}
          contained={'primary'}
          size={'large'}
          text={'Start recording'}
          onClick={onStartRecord}
          disabled={!stream}
          fullWidth
        />
      )}
    </div>
  )
})
